import Bluebird from 'bluebird'
// import { map, orderBy } from 'lodash'
import {definitionAsString} from '@/helpers'
import jsPDF from 'jspdf'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
// import { Workbook } from '@/helpers/excel/excelSheets'
import LASDownloadableGrpahs from '@/appComponents/graphs/LASDownloadableGraphs.vue'
import {renderComponent} from '@/clientLogic/vue/utility'
import {toPNG} from '@/clientLogic/html2canvas/utility'

const downloadTarget = function ({target, audienceSize, targetDefinition, viewershipData
  , networks, universeData, ageMarketData, ageDistribution, meanAge, incomeDistribution}) {
  renderComponent({Component: LASDownloadableGrpahs}, {
    propsData: {
      viewershipData,
      networks,
      universeData,
      ageMarketBreakerData: ageMarketData,
      ageData: ageDistribution,
      incomeData: incomeDistribution,
      meanAge: meanAge
    }
  })
  return new Bluebird((resolve, reject) => {
    setTimeout(() => {
      // create the PDF of the target overview
      // eslint-disable-next-line
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'in',
        format: [8.5, 11]
      })
      doc.setFontSize(11)
      // TODO this section will be its own portion and rendered element as well...
      // unless we cant get a section of it as a text based section
      // use addHTML
      doc.text([
        `Name: ${target.display_name}`,
        '',
        `Created by: ${target.username} at ${target.created}`,
        '',
        `Audience Size: ${audienceSize}`,
        '',
        `Target:`,
        '',
        ...definitionAsString(targetDefinition)
      ], 0.5, 0.5)
      Bluebird.join(
        toPNG(document.getElementById('viewership-graph-pdf')),
        toPNG(document.getElementById('universe-graph-pdf')),
        toPNG(document.getElementById('age-market-breaker-graph-pdf')),
        toPNG(document.getElementById('age-graph-pdf')),
        toPNG(document.getElementById('income-graph-pdf')),
        function (viewershipGraph, universeGraph, ageMarketGraph, ageGraph, incomeGraph) {
          doc.addPage()
          doc.text('Viewership:', 0.5, 0.4)
          doc.addImage(viewershipGraph, 'PNG', 0.4, 0.5, 7.5, 2.5)
          doc.text('Universe:', 0.5, 3.5)
          doc.addImage(universeGraph, 'PNG', 0.5, 3.7, 7.5, 2.5)
          doc.addPage()
          doc.addImage(ageGraph, 'PNG', 0.5, 0.7, 7.5, 2.5)
          doc.addImage(ageMarketGraph, 'PNG', 0.5, 3.7, 7.5, 2.5)
          doc.addImage(incomeGraph, 'PNG', 0.5, 6.7, 7.5, 2.5)
          const targetSummaryPDF = doc.output('blob')
          var zip = new JSZip()
          zip.file('target-summary.pdf', targetSummaryPDF)
          zip.file('Viewership.jpeg', viewershipGraph.split(',')[1], {base64: true})
          zip.file('Universe.jpeg', universeGraph.split(',')[1], {base64: true})
          zip.file('Age-Market-Breaker.jpeg', ageMarketGraph.split(',')[1], {base64: true})
          zip.file('Age-Distribution.jpeg', ageGraph.split(',')[1], {base64: true})
          zip.file('Income-Distribution.jpeg', incomeGraph.split(',')[1], {base64: true})
          const zipFileName = `${target.display_name}.zip`
          zip.generateAsync({type: 'blob'}).then((content) => {
            FileSaver.saveAs(content, zipFileName)
            resolve(zipFileName)
          })
        }
      )
      // // Create the excel sheet with viewership data
      // const sheet = new Workbook({filename: target.display_name})
      // sheet.addSheetAOO(orderBy(map(viewershipData, (value, key) => {
      //   return {
      //     name: key,
      //     index: value.index,
      //     rating: value.rating,
      //     size: value.size
      //   }
      // }), 'size', 'desc'), 'Viewership data')
      // const viewershipExcel = sheet.rawData()
      // zip.file('viewership.xlsx', viewershipExcel, {base64: true})
    }, 5000)
  })
}

export default downloadTarget



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/currentTarget/DownloadTarget.js